'use strict';

angular.module('core').controller('SupportedLanguages', [
  '$scope', 'SupportedLanguages',
  function ($scope, SupportedLanguages) {
    SupportedLanguages.get(function (response) {
      $scope.supportedLangauges = response;
    });
  }
]);
